export function menuReducer(state = { data: { menu: "" } }, action) {
  switch (action.type) {
    case "GOT_MENU":
      const data = { ...action.payload }
      return data
    default:
      return state
  }
}
